 


import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const financeRoutes: RouteObject[] = [
  {
    path: 'FINANCE/Settings/*',
    children: [
      { path: 'FiscalYear', lazy: lazyRoute(() => import('../../pages/Finance/Settings/FiscalYear/Index')) },
      { path: 'DailyRates', lazy: lazyRoute(() => import('../../pages/Finance/Settings/DailyRates/Index')) },
      { path: 'JeCategory', lazy: lazyRoute(() => import('../../pages/Finance/Settings/JeCategory/Index')) },
      { path: 'JeSource', lazy: lazyRoute(() => import('../../pages/Finance/Settings/JeSource/Index')) },
      { path: 'VAT', lazy: lazyRoute(() => import('../../pages/Finance/Settings/VAT/Index')) },
      { path: 'AccountingPeriod', lazy: lazyRoute(() => import('../../pages/Finance/Settings/AccountingPeriod/Index')) },

      { path: 'ChartAccounts', lazy: lazyRoute(() => import('../../pages/Finance/ChartAccounts/Index')) },

      {
        path: 'ChartAccounts/:ChartAccountsId/ChartAccountsDetails',
        lazy: lazyRoute(() => import('../../pages/Finance/ChartAccountsDetails/Accounts/Index'))
        // lazy: lazyRoute(() => import('../../pages/Finance/ChartAccountsDetails/AccountsTest/Index'))
      },
      {
        path: 'ChartAccounts/:ChartAccountsId/CompaniesAndBranches',
        lazy: lazyRoute(() => import('../../pages/Finance/ChartAccountsDetails/CompaniesAndBranches/Index'))
      },
      {
        path: 'ChartAccounts/:ChartAccountsId/CostCenters',
        lazy: lazyRoute(() => import('../../pages/Finance/ChartAccountsDetails/CostCenters/Index'))
      },

      { path: 'Ledgers', lazy: lazyRoute(() => import('../../pages/Finance/Settings/Ledgers/Index')) },
      { path: 'ConsolidationSet', lazy: lazyRoute(() => import('../../pages/Finance/Settings/ConsolidationSet/ConsolidationSet')) },

      { path: 'TypesOfExpenses', lazy: lazyRoute(() => import('../../pages/Finance/Settings/TypesOfExpenses/ExpenseCategory/Index')) },
      { path: 'BankAccounts', lazy: lazyRoute(() => import('../../pages/Finance/Settings/BankAccounts/Index')) },
      { path: 'CashBoxes', lazy: lazyRoute(() => import('../../pages/Finance/Settings/CashBoxes/Index')) },

      { path: 'PaymentTerms', lazy: lazyRoute(() => import('../../pages/Finance/Settings/PaymentTerms/Index')) }
    ]
  },

  {
    path: 'FINANCE/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/Finance/Main/FinancialDashboard')) },

      { path: 'Journals', lazy: lazyRoute(() => import('../../pages/Finance/Journals/Index')) },
      // { path: 'Journals/:ledgerId/AddJournals', lazy: lazyRoute(() => import('../../pages/Finance/Journals/AddJournals/AddJournals')) },
      { path: 'Journals/AddJournals', lazy: lazyRoute(() => import('../../pages/Finance/Journals/AddJournals/AddJournals')) },
      { path: 'Journals/:Id/UpdateJournals', lazy: lazyRoute(() => import('../../pages/Finance/Journals/UpdateJournals/UpdateJournals')) },
      { path: 'PostingJournals', lazy: lazyRoute(() => import('../../pages/Finance/Journals/PostJournals/UnPostedJournalsList')) }
    ]
  },

  {
    path: 'FINANCE/*',
    children: [
      { path: 'Budget', lazy: lazyRoute(() => import('../../pages/Finance/Budget/Index')) },
      { path: 'Budget/:id/UpdateBudget', lazy: lazyRoute(() => import('../../pages/Finance/Budget/Update')) }
    ]
  },

  {
    path: 'FINANCE/*',
    children: [
      { path: 'ControlCodeCombinations', lazy: lazyRoute(() => import('../../pages/Finance/ControlCodeCombinations/Index')) },
      { path: 'CashTransfer', lazy: lazyRoute(() => import('../../pages/Finance/CashTransfer/Index')) }
    ]
  },

  {
    path: 'FINANCE/Report/*',
    children: [
      { path: 'IncomeStatement', lazy: lazyRoute(() => import('../../pages/Finance/FinancialReports/IncomeStatement')) },
      { path: 'BalanceSheet', lazy: lazyRoute(() => import('../../pages/Finance/FinancialReports/BalanceSheet')) },
      { path: 'AuditBalance', lazy: lazyRoute(() => import('../../pages/Finance/FinancialReports/AuditBalance')) },
      { path: 'AccountStatement', lazy: lazyRoute(() => import('../../pages/Finance/FinancialReports/AccountStatement')) }
    ]
  },
    // Reports
    { path: 'FINANCE/Reports', lazy: lazyRoute(() => import('../../pages/Finance/Reports/FinanceReports')) },
];

export default financeRoutes;
